import React from 'react';

const UserReportDetails = ({ report }) => (
  <div className='bg-white rounded shadow p-4 mb-6'>
    <h2 className='text-lg font-bold mb-4'>Report Details</h2>
    <table className='w-full'>
      <tbody>
        <tr>
          <td className='font-medium pr-4 py-1 text-gray-700'>Email</td>
          <td className='py-1'>{report?.email ?? '-'}</td>
        </tr>
        <tr>
          <td className='font-medium pr-4 py-1 text-gray-700'>Status</td>
          <td className='py-1'>{report?.status ?? '-'}</td>
        </tr>
        <tr>
          <td className='font-medium pr-4 py-1 text-gray-700'>Test Name</td>
          <td className='py-1'>{report?.test_name ?? '-'}</td>
        </tr>
        <tr>
          <td className='font-medium pr-4 py-1 text-gray-700'>Total Score</td>
          <td className='py-1'>{report?.total_score ?? '-'}</td>
        </tr>
        <tr>
          <td className='font-medium pr-4 py-1 text-gray-700'>Max Score</td>
          <td className='py-1'>{report?.max_score ?? '-'}</td>
        </tr>
        <tr>
          <td className='font-medium pr-4 py-1 text-gray-700'>Percentage</td>
          <td className='py-1'>{report?.verdict?.percentage ? `${report.verdict.percentage}%` : '-'}</td>
        </tr>
        <tr>
          <td className='font-medium pr-4 py-1 text-gray-700'>Verdict</td>
          <td className='py-1'>{report?.verdict?.verdict ?? '-'}</td>
        </tr>
        <tr>
          <td className='font-medium pr-4 py-1 text-gray-700'>Quality Score</td>
          <td className='py-1'>{report?.verdict?.quality_score ?? '-'}</td>
        </tr>
        <tr>
          <td className='font-medium pr-4 py-1 text-gray-700'>Quality Verdict</td>
          <td className='py-1'>{report?.verdict?.quality_verdict ?? '-'}</td>
        </tr>
        <tr>
          <td className='font-medium pr-4 py-1 text-gray-700'>Accepted</td>
          <td className='py-1'>{report?.accepted ?? '-'}</td>
        </tr>
        <tr>
          <td className='font-medium pr-4 py-1 text-gray-700'>Rejected</td>
          <td className='py-1'>{report?.rejected ?? '-'}</td>
        </tr>
        <tr>
          <td className='font-medium pr-4 py-1 text-gray-700'>Started At</td>
          <td className='py-1'>{report?.started_at ? new Date(report.started_at).toLocaleString() : '-'}</td>
        </tr>
        <tr>
          <td className='font-medium pr-4 py-1 text-gray-700'>Ended At</td>
          <td className='py-1'>{report?.ended_at ? new Date(report.ended_at).toLocaleString() : '-'}</td>
        </tr>
        <tr>
          <td className='font-medium pr-4 py-1 text-gray-700'>Time Taken (s)</td>
          <td className='py-1'>{report?.time_taken ?? '-'}</td>
        </tr>
        <tr>
          <td className='font-medium pr-4 py-1 text-gray-700'>Total Problems</td>
          <td className='py-1'>{report?.total_problems ?? '-'}</td>
        </tr>
        <tr>
          <td className='font-medium pr-4 py-1 text-gray-700'>Total Solutions</td>
          <td className='py-1'>{report?.total_solutions ?? '-'}</td>
        </tr>
        <tr>
          <td className='font-medium pr-4 py-1 text-gray-700'>Assessment Type</td>
          <td className='py-1'>{report?.assessment_type ?? '-'}</td>
        </tr>
        <tr>
          <td className='font-medium pr-4 py-1 text-gray-700'>Public Report Link</td>
          <td className='py-1'>
            {report?.public_access_url ? (
              <a
                href={report.public_access_url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline"
              >
                View Report
              </a>
            ) : (
              '-'
            )}
          </td>
        </tr>
        {/* Add more fields as needed */}
      </tbody>
    </table>
    {/* Example: Show tags as a list */}
    {/* {report?.insights?.tags && report.insights.tags.length > 0 && (
      <div className="mt-4">
        <div className="font-bold mb-2">Tags & Scores:</div>
        <ul className="list-disc list-inside">
          {report.insights.tags.map((tag, idx) => (
            <li key={idx}>
              <span className="font-medium">{tag.label}:</span> {tag.value}
            </li>
          ))}
        </ul>
      </div>
    )} */}
    {/* Example: Show technologies used */}
    {/* {report?.insights?.technologies_used && report.insights.technologies_used.length > 0 && (
      <div className="mt-2">
        <div className="font-bold mb-2">Technologies Used:</div>
        <div>{report.insights.technologies_used.join(', ')}</div>
      </div>
    )} */}
  </div>
);

export default UserReportDetails;